import React from 'react';
import { Grid as Component } from '@vfuk/core-grid';
const Grid = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Grid;
